import api from '@/api';

const { $student: $studentApi } = api;
const $api_academic = api.$academic;
const { $report } = api;
const { $exam, $student, $list, $academic, $payment, $s3 } = $report;

export const { $sellersReporting } = $report
export const { $terms } = $api_academic;
export const { $tools } = $studentApi;
export const $reports = { exam: $exam, student: $student, list: $list, academic: $academic, payment: $payment, s3: $s3 }